// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"headerTitle_HeaderTitle__hCxis"};